import { usePermissions } from '@/hooks/usePermissions'
import {
  HiOutlineExclamation,
  HiOutlineInformationCircle,
} from 'react-icons/hi'

import { Box } from '@chakra-ui/react'

import { DocumentText } from '@/components/icons'
import {
  DeviceAlerts,
  DeviceInfoTab,
  DeviceLogs,
  DrawerTabIProps,
} from '@/features/device-drawer'

export const useDeviceDrawerTabs = ({
  incidents,
  isIncidentsLoading,
  deviceId,
}): DrawerTabIProps[] => {
  const { isImplementer } = usePermissions()

  const tabs: DrawerTabIProps[] = [
    {
      label: 'Recent Incidents',
      icon: <HiOutlineExclamation className='tab-btn__icon' size={18} />,
      panel: (
        <DeviceAlerts incidents={incidents} isLoading={isIncidentsLoading} />
      ),
    },
  ]

  if (isImplementer) {
    tabs.push({
      label: 'Device Info',
      icon: <HiOutlineInformationCircle className='tab-btn__icon' size={18} />,
      panel: <DeviceInfoTab id={deviceId} />,
    })
    tabs.push({
      label: 'Device Logs',
      icon: (
        <Box className='tab-btn__icon'>
          <DocumentText />
        </Box>
      ),
      panel: <DeviceLogs deviceId={deviceId} />,
    })
  }

  return tabs
}
